<template>
    <main-layout>

        <app-header icon="tools">
            Controles d'etancheite
        </app-header>

        <nav id="action-top" class="wrap" style="display: flex; justify-content: space-between">
            <router-link class="btn prev btn-full" :to="{name : 'home'}">
                <i class="icon-go"></i>
                <span>
                    <strong>Retour</strong>
                </span>
            </router-link>

            <button type="button" class="btn" @click="confirmResetAll" style="margin: 0">Tout effacer</button>
        </nav>

        <form id="ctrl-multi" class="wrap" @submit.prevent>

            <h2>RÉFÉRENCE BON ET / OU NOM TECHNICIEN</h2>
            <input title="ref" type="text" @change="changeValue('ordreTravail')" name="ordre" v-model="ordreTravail" maxlength="100">

            <div class="check">
                <input type="checkbox" @change="changeValue('contractuel')" id="contract" v-model="contractuel">
                <label for="contract" class="btn check">
                    Intervention contractuelle
                    <i class="icon-valid"></i>
                </label>
            </div>

            <h2>DÉTENTEUR *</h2>
            <v-select
                id="id-detenteur"
                :filterable="false"
                :on-change="loadInstall"
                :options="detenteursFiltred"
                @search="onSearch">
            </v-select>

            <div class="installations">
                <h2>INSTALLATIONS CONTROLÉES *</h2>
                <button type="button" class="btn hide" @click="scanOtag" >Scan Otag Install</button>
            </div>

            <div class="checkfull" v-for="i in installations" :key="i.id">
                <input title="install" type="checkbox" :id="'modification-' + i.id" :value="i.id" @change="checkInstall" :disabled="installSelected.indexOf(i) === -1 && locked === true">
                <label class="btn check" :for="'modification-' + i.id">
                    <div class="rondbleue" v-if="displayPastille(i) === true"></div>
                    {{ i.nom }}
                    {{ (i.marque) ? ' - ' + i.marque : '' }}
                    {{ (i.modele) ? ' - ' + i.modele : '' }}
                    <span v-if="i.fluide !== null && i.fluide.type === 'HFO'" class="HFO-logo">HFO</span>
                    <i class="icon-valid"></i>
                </label>
            </div>

            <div v-show="installSelected.length !== 0" ref="validation">

                <h2>CONTRÔLE D'ÉTANCHÉITÉ *</h2>
                <div class="checkfull" >
                    <input type="checkbox" id="nofuite" @change="changeValue('noFuite')" value="1" v-model="noFuite">
                    <label class="btn check blue" for="nofuite">Aucune fuite constatée
                        <i class="icon-valid"></i>
                    </label>
                </div>

                <h2>ENTRETIEN-CONTRÔLE</h2>
                <div class="checkfull">
                    <input type="checkbox" id="nettoyage" @change="changeValue('nettoyage')" value="1" v-model="nettoyage">
                    <label class="btn check blue" for="nettoyage">Nettoyage de base réalisé
                        <i class="icon-valid"></i>
                    </label>
                </div>
                <div class="checkfull">
                    <input type="checkbox" id="ctrlFonctionnement" @change="changeValue('ctrlFonctionnement')" value="1" v-model="ctrlFonctionnement">
                    <label class="btn check blue" for="ctrlFonctionnement">Contrôle de bon fonctionnement réalisé
                        <i class="icon-valid"></i>
                    </label>
                </div>

                <h2>SIGNATURE</h2>
                <label>Nom signataire *</label>
                <input title="signName" @change="changeValue('nomSignataire')" v-model="nomSignataire" type="text" name="nom_acquereur" value="" required maxlength="255">

                <label>Fonction signataire *</label>
                <input title="signFunction" @change="changeValue('fonctionSignataire')" v-model="fonctionSignataire" type="text" name="nom_acquereur" value="" required maxlength="255">

                <a class="btn add btn-full" id="main-action" :class="interventionIsOk && !submitting ? '' : 'disabled'"
                   href="javascript: void 0" @click.prevent="triggerSignature">
                    <i class="icon-checktodo"></i>
                    <strong>Signer et Clôturer</strong>les fiches
                </a>

                <a class="btn add btn-full cloturer" :class="interventionIsOkWithNoSignature && !submitting ? '' : 'disabled'"
                   href="javascript: void 0" @click.prevent="triggerSignatureWithNoSignature"
                   id="clotureWithoutSignature"
                   style="margin: 20px 5px;"
                   :style="interventionIsOkWithNoSignature && !submitting ? 'background-color: #86bc24' : ''">
                   <i class="icon-error icon-checktodo"></i>
                   <strong>Clôturer détenteur absent</strong> Les fiches
                </a>

                <signature-modal
                        v-show="showModal"
                        :signature="signatureSignataire"
                        :clearOnClose="true"
                        @signatureUpdated="updateSignature"
                        @close="showModal = false">
                </signature-modal>


            </div>

        </form>

    </main-layout>
</template>

<script>

    import $ from 'jquery'
    import Detenteur from '../../../js/models/Detenteur'
    import Installation from '../../../js/models/Installation'
    import Outil from '../../../js/models/Outil'
    import Fibsdd from '../../../js/models/Fibsdd'
    import SignatureModal from '../../common/SignatureModal.vue'
    import Offline from '../../../js/models/Offline'

    import vSelect from 'vue-select'

    export default {

        data() {
            return {
                detenteursOpt: [],
                detenteursFiltred: [],
                installations: [],

                installSelected: [],
                detenteurSelected: null,
                ordreTravail: null,
                contractuel: false,
                noFuite: false,
                nettoyage: false,
                ctrlFonctionnement: false,
                nomSignataire: null,
                fonctionSignataire: null,
                signatureSignataire: null,
                detecteur: null,
                locked: false,
                submitting: false,

                showModal: false,
                localStorage: 'listCtrlMulti'
            }
        },

        computed: {

            interventionIsOk(){
                return (
                    this.detenteurSelected &&
                    this.nomSignataire &&
                    this.fonctionSignataire &&
                    this.installSelected.length !== 0 &&
                    this.noFuite &&
                    this.detecteur
                );
            },

            interventionIsOkWithNoSignature() {
                return (
                    this.detenteurSelected &&
                    this.installSelected.length > 0 &&
                    this.noFuite &&
                    this.detecteur &&
                    !this.nomSignataire &&
                    !this.fonctionSignataire
                )
            }

        },

        methods: {
            scanOtag() {
                if (typeof window.flutter_inappwebview !== 'undefined') {
                    window.flutter_inappwebview.callHandler('scanOtag');
                }
            },
            getInstallation(result) {
                let otag = null;

                if(result.indexOf('#install') > 0) {
                    otag = result.split('#install')[1];
                } else if(result.indexOf('://installation/') > 0) {
                    otag = result.split('/installation/')[1];
                } else if(result.indexOf('bouteille.php#id') > 0 || result.indexOf('://bouteille/') > 0) {
                    swal.close();
                    swal({
                        title: 'Oops',
                        text: "Vous avez scanné une puce O-TAG bouteille, veuillez utiliser une puce O-TAG Install",
                        type: 'warning',
                    })
                    return;
                }

                if (otag != null) {
                    this.selectInstallation(otag);
                }
            },
            selectInstallation(otag) {
                let install = _.find(this.installations, i => i.i_tag == otag);

                if (install) {
                    let input = $(`#modification-${install.id}`);

                    if(input.prop('checked') === false) {
                        input.prop('checked', true);
                        this.checkInstall({target: {checked: true, value: install.id}});
                    } else {
                        input.prop('checked', false);
                        this.checkInstall({target: {checked: false, value: install.id}});
                    }
                } else {
                    swal({
                        title: 'Installation non trouvée',
                        text: "L'installation n'a pas été trouvée",
                        type: 'error',
                    })
                }
            },
            confirmResetAll() {
                swal({
                    title: 'Tout effacer ?',
                    text: 'Toutes les informations saisies seront effacées.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Effacer',
                    cancelButtonText: 'Annuler',
                }).then(() => {
                    this.resetValues(true);
                }, () => {})
            },
            resetValues(all = false) {
                    this.installSelected = [];
                    this.noFuite = false;
                    this.nettoyage = false;
                    this.ctrlFonctionnement = false;
                    this.nomSignataire = null;
                    this.fonctionSignataire = null;
                    this.signatureSignataire = null;
                    this.locked = false;
                    if(all === true){
                        localStorage.removeItem(this.localStorage);
                        localStorage.setItem(this.localStorage, JSON.stringify({}));
                        this.ordreTravail = null;
                        this.contractuel = false;
                        this.checkInstallationWithLocalStorage();
                        $('.selected-tag').remove();
                        this.installations = [];
                        this.detenteurSelected = null;
                        let btnScanOtag = document.querySelector('.installations .btn');
                        btnScanOtag.classList.add('hide');
                        window.wantReload();
                    }
            },

            changeValue(key) {
                if(key === 'noFuite'){
                    this.updateLocalStorage('noFuite', this.noFuite);
                }else if(key === "nettoyage") {
                    this.updateLocalStorage('nettoyage', this.nettoyage);
                }else if(key === "ctrlFonctionnement") {
                    this.updateLocalStorage('ctrlFonctionnement', this.ctrlFonctionnement);
                }else if(key === "ordreTravail") {
                    this.updateLocalStorage('ordreTravail', this.ordreTravail);
                }else if(key === "contractuel") {
                    this.updateLocalStorage('contractuel', this.contractuel);
                }else if(key === "nomSignataire") {
                    this.updateLocalStorage('nomSignataire', this.nomSignataire);
                }else if(key === "fonctionSignataire") {
                    this.updateLocalStorage('fonctionSignataire', this.fonctionSignataire);
                }
            },

            // Recalculée ici : la fréquence stockée peut être périmée (l'API garde celle envoyée par l'app à la mise à jour).
            displayPastille(install) {
                if (install.force_frequence === true) {
                    return Number(install.frequence_controle) > 0;
                }

                return Installation.calcFrequence(install.detecteur, install.tonnage, install.charge, install.fluide) > 0;
            },

            cleanChampDetenteur(det) {

                if($('#id-detenteur').find('.vs__selected-options > span').length > 1){
                    $('#id-detenteur').find('.vs__selected-options > span:first').remove();
                }

                if($('#id-detenteur').find('.vs__selected-options > span').length === 0){
                    $('#id-detenteur').find('.vs__selected-options').prepend('<span class="selected-tag">' + det.label + ' <!----></span>');
                }
            },

            async checkInstallationWithLocalStorage() {

                let installSelected = this.installSelected;

                $.each($('.checkfull > input[id^=modification]'), function (d, v) {

                    //v.value // Value du input
                    if(installSelected.filter(i => i.id == v.value).length > 0){
                        $(v).prop('checked', true);
                    }else{
                        $(v).prop('checked', false);
                    }

                })
            },

            updateLocalStorage(type, val) {

                let localStorageCtrlMulti = localStorage.getItem(this.localStorage);
                let localStorageCtrlMultiObj = JSON.parse(localStorageCtrlMulti) || {};
                localStorageCtrlMultiObj[type] = type === 'installSelected' ? val.map(i => i.id) : val;

                localStorage.setItem(this.localStorage, JSON.stringify(localStorageCtrlMultiObj));

            },

            async updatePage() {
                let localStorageCtrlMulti = localStorage.getItem(this.localStorage);
                let localStorageCtrlMultiObj = JSON.parse(localStorageCtrlMulti);

                if(localStorageCtrlMultiObj.hasOwnProperty('detenteurSelected') && localStorageCtrlMultiObj.detenteurSelected != null){
                    this.detenteurSelected = localStorageCtrlMultiObj.detenteurSelected;

                    let det = await Detenteur.getDetenteur(this.detenteurSelected);
                    let cc = (det.code_client) ? ` (${det.code_client})` : '';

                    $('#id-detenteur').find('.vs__selected-options').prepend('<span class="selected-tag"> ' + det.raison_sociale + cc + ' - ' + det.ville + ' / '+ det.code_postal + ' <!----></span>');

                    await this.loadInstall({'label' : det.raison_sociale + cc + ' - ' + det.ville + ' / '+ det.code_postal, 'value' : det.id});

                }

                if(localStorageCtrlMultiObj.hasOwnProperty('installSelected')){
                    const ids = localStorageCtrlMultiObj.installSelected;
                    this.installSelected = ids.map(id => this.installations.find(i => i.id == id)).filter(Boolean);

                    await this.checkInstallationWithLocalStorage();
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('noFuite')){
                    this.noFuite = localStorageCtrlMultiObj.noFuite;
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('nettoyage')){
                    this.nettoyage = localStorageCtrlMultiObj.nettoyage;
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('ctrlFonctionnement')){
                    this.ctrlFonctionnement = localStorageCtrlMultiObj.ctrlFonctionnement;
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('ordreTravail')){
                    this.ordreTravail = localStorageCtrlMultiObj.ordreTravail;
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('contractuel')){
                    this.contractuel = localStorageCtrlMultiObj.contractuel;
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('nomSignataire')){
                    this.nomSignataire = localStorageCtrlMultiObj.nomSignataire;
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('fonctionSignataire')){
                    this.fonctionSignataire = localStorageCtrlMultiObj.fonctionSignataire;
                }
            },

            triggerSignature(){
                if(this.submitting) {
                    return;
                }

                if(this.interventionIsOk){
                    this.showModal = true
                } else {
                    swal({
                        title: 'Contrôle incomplet',
                        text: 'Veuillez compléter la fiche',
                        type: 'warning'
                    })
                }
            },

            triggerSignatureWithNoSignature() {
                if(this.submitting) {
                    return;
                }

                if(this.interventionIsOkWithNoSignature){
                    swal({
                        title: 'Clôturer sans signature ?',
                        text: "Les fiches seront clôturées sans signature du détenteur. Cette action est définitive.",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Clôturer',
                        cancelButtonText: 'Annuler',
                    }).then(() => {
                        this.preSendForm();
                    }, () => {})
                } else {
                    swal({
                        title: 'Contrôle incomplet',
                        text: 'Veuillez compléter la fiche',
                        type: 'warning'
                    })
                }
            },

            async createFiches(mail){
                let fiObj = new Fibsdd();
                let i = 1;
                let timestamp = '' + +new Date();
                timestamp = timestamp.slice(0, -3);

                for(let install of this.installSelected){

                    let num = timestamp + '-' + i;
                    i++;
                    let payload = {};

                    payload.numero = num;
                    payload.ordre_travail = this.ordreTravail;
                    payload.detenteur = this.detenteurSelected;
                    payload.installation = install.id;
                    payload.charge_init = install.charge;
                    payload.fluide_init = install.fluide.id;
                    payload.detecteur = this.detecteur;
                    payload.cloture = true;
                    payload.cloturedAt = moment().format('YYYY-MM-DD HH:mm:ss');

                    payload.natures = {};
                    payload.natures.assemblage =  false;
                    payload.natures.miseEnService =  false;
                    payload.natures.modification =  false;
                    payload.natures.maintenance =  false;
                    payload.natures.controlePeriodique =  true;
                    payload.natures.controleNonPeriodique =  false;
                    payload.natures.demantelement =  false;
                    payload.natures.retrofit =  false;
                    payload.natures.newFluide =  null;
                    payload.natures.autres =  null;
                    payload.natures.observations =  null;
                    payload.natures.description =  null;
                    payload.natures.contractuel =  this.contractuel;

                    payload.ctrlEtanch = {};
                    payload.ctrlEtanch.no_fuites = true;

                    payload.infosDet = {};
                    payload.infosDet.nom_signataire = this.nomSignataire;
                    payload.infosDet.fonction_signataire = this.fonctionSignataire;
                    payload.infosDet.signature_signataire64 = this.signatureSignataire;
                    payload.multiCtrl = true;
                    payload.nettoyage = this.nettoyage;
                    payload.ctrlFonctionnement = this.ctrlFonctionnement;

                    let newId = await fiObj.addOfflineFibsdd(payload);

                    await Offline.saveAction({
                        action: 'add',
                        type: 'clotureFibsdd',
                        sendMail: mail,
                        detenteur: this.detenteurSelected,
                        idFi: newId
                    })

                }

                localStorage.removeItem('listCtrlMulti');

                const goHome = () => {
                    this.$router.push('home')
                };

                swal('Contrôles terminés', "Vos contrôles d'étanchéité sont cloturés", 'success').then(goHome, goHome)

            },

            async preSendForm() {
                if(this.submitting) {
                    return;
                }

                this.submitting = true;

                try {
                    let det = await Detenteur.getDetenteur(this.detenteurSelected);
                    let mail = false;

                    if(det.email) {
                        mail = await swal({
                            title: 'Envoi du rapport',
                            text: "Voulez vous envoyer la fiche d'intervention au détenteur ?",
                            type: 'question',
                            showConfirmButton: true,
                            confirmButtonText: 'Oui',
                            showCancelButton: true,
                            cancelButtonText: 'Non'
                        }).then(() => true, () => false)
                    }

                    await this.createFiches(mail)
                } catch (e) {
                    this.submitting = false;
                    swal({
                        title: 'Erreur lors de la clôture',
                        text: "Certaines fiches ont peut-être déjà été créées. Vérifiez la liste des fiches avant de relancer la clôture.",
                        type: 'error'
                    }).then(() => {}, () => {})
                    throw e;
                }
            },

            async fetchDetenteurs() {

                let dets = _.sortBy(await Detenteur.getList(), det => det.raison_sociale.toUpperCase());
                this.detenteursOpt = dets.map( det => {
                    let cc = (det.code_client) ? ` (${det.code_client})` : '';
                    return {
                        value: det.id,
                        label: det.raison_sociale + cc + ' - ' + det.ville + ' / '+ det.code_postal
                    }
                });

                this.detenteursFiltred = this.detenteursOpt.slice(0, 20);
                this.onSearch('', false)

            },

            async fetchDetecteur() {

                Outil
                    .getDetecteurActif()
                    .then(data => {
                        this.detecteur = data.id
                    })
                    .catch(() => {
                        swal('Aucun détecteur de fuite', "Vous n'avez pas renseigné votre détecteur de fuites", 'warning')
                    })

            },

            onSearch(str) {
                str = this.normalize(str);

                this.detenteursFiltred = this.detenteursOpt.filter( det =>  {
                    if(this.normalize(det.label).includes(str)) { return det }
                }).slice(0, 20)
            },

            normalize(s) {
                let r = s.toLowerCase();

                r = r.replace(new RegExp(/\s/g),"");
                r = r.replace(new RegExp(/[àáâãäå]/g),"a");
                r = r.replace(new RegExp(/æ/g),"ae");
                r = r.replace(new RegExp(/ç/g),"c");
                r = r.replace(new RegExp(/[èéêë]/g),"e");
                r = r.replace(new RegExp(/[ìíîï]/g),"i");
                r = r.replace(new RegExp(/ñ/g),"n");
                r = r.replace(new RegExp(/[òóôõö]/g),"o");
                r = r.replace(new RegExp(/œ/g),"oe");
                r = r.replace(new RegExp(/[ùúûü]/g),"u");
                r = r.replace(new RegExp(/[ýÿ]/g),"y");
                r = r.replace(new RegExp(/\W/g),"");

                return r;
            },

            async loadInstall(det) {

                let btnScanOtag = document.querySelector('.installations .btn');
                this.installSelected = [];

                if(det === null){
                    this.detenteurSelected = null;
                    this.installations = []
                    btnScanOtag.classList.add('hide');
                } else {
                    this.detenteurSelected = det.value;
                    let installsDet = await Installation.getInstallationsForDet(det.value);

                    let localStorageCtrlMulti = localStorage.getItem(this.localStorage);
                    let localStorageCtrlMultiObj = JSON.parse(localStorageCtrlMulti);

                    if(localStorageCtrlMultiObj['detenteurSelected'] != det.value) {
                        localStorage.removeItem(this.localStorage);
                        this.resetValues();
                        localStorage.setItem('listCtrlMulti', JSON.stringify({}));
                        this.updateLocalStorage('detenteurSelected', det.value);
                        this.checkInstallationWithLocalStorage();

                    }


                    this.installations = installsDet.filter( i => {
                        if( _.has(i, 'fluide') && ! _.isEmpty(i.fluide) ){
                            var typeFluide = i.fluide.type;
                            if(typeFluide === 'HFC' || typeFluide === 'HCFC' || typeFluide === 'CFC' || typeFluide === 'Mélange HFO/HFC' || typeFluide === 'HFO'){
                                return i
                            }
                        }
                    })

                    this.cleanChampDetenteur(det);
                    btnScanOtag.classList.remove('hide');
                }

            },

            checkInstall(val){
                let install = _.find(this.installations, i => i.id == val.target.value);

                if(val.target.checked === true){
                    this.installSelected.push(install)
                } else {
                    _.remove(this.installSelected, i => i.id == val.target.value)
                }

                this.updateLocalStorage('installSelected', this.installSelected);

                this.noFuite = false;
                this.nomSignataire = '';
                this.fonctionSignataire = '';
                this.signatureSignataire = '';

                if(this.installSelected.length > 19){
                    this.locked = true;
                }else{
                    this.locked = false;
                }

            },

            updateSignature(data) {
                this.signatureSignataire = data;
                this.preSendForm();
            }

        },

        mounted() {

            this.fetchDetenteurs();
            this.fetchDetecteur();

            if(localStorage.hasOwnProperty('listCtrlMulti')) {
                this.updatePage()
            }else{
                localStorage.setItem('listCtrlMulti', JSON.stringify({}));
            }

            window.getInstallation = this.getInstallation;

        },

        beforeDestroy() {
            if(window.getInstallation === this.getInstallation) {
                delete window.getInstallation;
            }
        },

        components: {
            SignatureModal,
            vSelect
        }

    }

</script>

<style scoped>

    .HFO-logo {
        position: absolute;
        right: 50px;
        background: white;
        border: 0.5px solid darkgreen;
        border-radius: 24%;
        padding: 6px 2px;
        color: black;
    }

    .installations {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .installations .btn {
        margin: 0;
        max-width: 150px;
        background-color: rgb(234, 94, 11);
    }

    .check input {
        display: none;
    }

    .check input:checked + label {
        color: white;
        background-color: #86bc24;
    }

    .check input:checked + label i {
        color: white;
    }

    .check label {
        position: relative;
        background-color: #e2e2e2;
        color: #999;
        margin-bottom: 5px;
        padding: 0px 10px;
        font-family: "Open Sans";
        font-size: 1.5rem;
        font-weight: 400;
        text-transform: none;
        transition: all 250ms ease;
    }

    .check label i {
        position: absolute;
        right: 10px;
        font-size: 2.3rem;
        color: #999;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .rondbleue {
        position: absolute;
        left: 6px;
        height: 10px;
        width: 10px;
        background-color: #5698d2;
        border-radius: 50%;
    }

    #ctrl-multi h2 {
        margin-top:20px;
        margin-bottom:10px;
    }

    #main-action{
        margin-left: 0;
        margin-bottom: 20px;
    }

    #id-detenteur{
        margin-bottom: 20px;
    }

    div.checkfull label.btn.check {
        position: relative;
        background-color: #e2e2e2;
        color: #999;
        padding-left: 20px;
        font-size: 1.3rem;
        line-height: 1;
        font-weight: 400;
        text-transform: none;
        margin-bottom: 15px;
        margin-top: 15px;
    }

    div.checkfull label.btn.check i {
        position: absolute;
        top: 10px;
        font-size: 2.3rem;
        right: 15px;
        color: #999;
    }

    div.checkfull input[type="checkbox"]{
        display: none;
    }

    input:checked + label.btn.check {
        background-color: #86bc24;
        color: #fff;
    }

    input:checked + label.btn.blue {
        background-color: #5698d2;
        color: #fff;
    }


    input:checked + label.btn.check i {
        color: #fff;
    }


    .btn-signature {
        background-color: #5698d2;
        color: white;
        width: 120px;
        padding-left: 20px;
        margin: auto;
        margin-top: 15px;
        margin-bottom: 20px;
    }

    .btn-signature i {
        right: 0;
        top: 50%;
        margin-top: -16px;
        font-size: 3rem;
    }

    #main-action.disabled{
        background-color: #e2e2e2;
        color: #999;
        font-style: italic;
    }

</style>



// WEBPACK FOOTER //
// MultiCtrlEtanch.vue?53765c9c